import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

import { CustomLoader } from '../../../services/Reducer';
import apiClient from '../../../api/apiClient';
import authServices from '../../../services/AuthServices';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Add_table = ({ show, toggle, refreshData, AddcurrentPage }) => {
  const token = authServices.getToken();

  const [formData, setFormData] = useState({
    Content: '',
    Subject: ''
  });

  const [data, setData] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const fetchUserId = async () => {
    try {
      const response = await apiClient.get(`/api/admin/users/getAllByUserType?userType=user`, {

        headers: {
          access_token: token,
        },
      });

      // Ensure data exists before setting state
      if (response.data && response.data.data) {
        setData(response.data.data); // Assigning 'data' directly from API response
      } else {
        console.error('Invalid API response format:', response);
        setData([]); // Fallback to empty array
      }
    } catch (err) {
      console.error('Error fetching data:', err);
      setData([]); // Fallback to empty array in case of error
    }
  };
  const validData = data.filter((item) => item.name);



  const [selectedNumber, setSelectedNumber] = useState(null);

  const Numbers = Array.from({ length: 30 }, (_, index) => ({
    id: index + 1,
    Day: `${index + 1} Day`,
  }));

  const [errors, setErrors] = useState({}); // Error state
  const dispatch = useDispatch();

  const loader = (display) => {
    dispatch(CustomLoader(display));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Clear the error for the field being edited
    setErrors({ ...errors, [name]: '' });
  };


  const AllData = {
    subject: formData.Subject,
    contents: formData.Content,
    days: selectedNumber ? selectedNumber : 1,
    userId: {
      id: selectedUserId ? selectedUserId : null,
    }
  }
  const handleSubmit = async (e) => {
    // e.preventDefault();
    loader('enable');

    try {

      const response = await apiClient.post('/api/admin/notification/add', AllData, {

        headers: {
          'access_token': token,
        },

      });
      if (response.data.Status === "SUCCESS") {

        setFormData({
          Content: '',
          Subject: ''
        });
        setSelectedNumber('')
        setSelectedUserId('')
        toggle(); // Close the modal after submission
        toast.success(response.data.message)

      }
      else {
        toast.error(response.data.message)
        console.log(response.data.message)
      }
    }
    catch (error) {
      toast.error(error.response.data.message)
      console.error('catch Error :- ', error.response ? error.response.data.message : error);
    }
    finally {
      refreshData(AddcurrentPage);
      loader('disable');

      // window.location.reload();
    }
  };

  useEffect(() => {
    fetchUserId()
  }, [])

  return (
    <>
      {show && (
        <>
          <div className="modal fade show d-block" id="exampleModalScrollable" tabIndex={-1} role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalScrollableTitle">Add Notification</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={toggle} >< RxCross2 /></button>
                </div>
                <div className="modal-body-custom">
                  <form >

                    <div className='row w-100'>
                      <div className="spacing w-100 d-inline-block" >
                        <label htmlFor="Subject" className="label-custom">Subject</label>
                        <input
                          type="text"
                          className={`input-custom copyPaste`}
                          id="Subject"
                          name="Subject"
                          value={formData.Subject}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className='row w-100'>

                      <div className="spacing w-50 d-inline-block">
                        <Autocomplete
                          disablePortal
                          options={validData}
                          getOptionLabel={(option) => `${option.name} - ${option.mobile}`} // Show "name" in dropdown
                          onChange={(event, newValue) => setSelectedUserId(newValue ? newValue.id : null)} // Store selected id in state
                          renderInput={(params) => <TextField {...params} label="Select User" />}
                          PaperComponent={(props) => (
                            <div
                              {...props}
                              style={{
                                maxHeight: 180,
                                overflowY: 'auto',
                                backgroundColor: 'white', // Set background color
                              }}
                            />
                          )}
                          // Custom styling to avoid the default scroll behavior
                          ListboxProps={{
                            style: {
                              padding: 0, // Remove padding
                              // overflowY: 'auto', // Ensure only one scrollbar
                            },
                          }}
                        />
                      </div>

                      <div className="spacing w-50 d-inline-block">
                        <Autocomplete
                          disablePortal
                          options={Numbers}
                          getOptionLabel={(option) => option.Day} // Show "Day" in dropdown
                          onChange={(event, newValue) =>
                            setSelectedNumber(newValue ? newValue.id : null) // Store selected id in state
                          }
                          renderInput={(params) => (
                            <TextField {...params} label="Select No Of Days" />
                          )}
                          PaperComponent={(props) => (
                            <div
                              {...props}
                              style={{
                                maxHeight: 180,
                                overflowY: 'auto',
                                backgroundColor: 'white', // Set background color
                              }}
                              // Custom styling to avoid the default scroll behavior
                              ListboxProps={{
                                style: {
                                  padding: 0, // Remove padding
                                  // overflowY: 'auto', // Ensure only one scrollbar
                                },
                              }}
                            />
                          )}
                        />

                      </div>
                    </div>

                    <div className='row w-100'>
                      <div className="spacing w-100 d-inline-block">
                        <label htmlFor="Content" className="label-custom">Content</label>
                        <textarea
                          className={`input-custom ${errors.Content ? 'input-error' : ''}`}
                          id="Content"
                          name="Content"
                          value={formData.Content}
                          onChange={handleChange}
                          rows="5" // Textarea ka height define karne ke liye rows use karein
                          cols="50" // Optional: Width ke liye cols ka use karein
                        />
                      </div>
                    </div>

                  </form>
                </div>

                <div className="modal-footer">

                  <button type="button" style={{ backgroundColor: '#F0F0F0', color: '#000', fontWeight: '500', border: "1px solid #d7dde2" }} className="btn " data-bs-dismiss="modal" onClick={toggle}>
                    Close
                  </button>
                  <button type="button" style={{ color: 'white', fontWeight: '500' }} className="btn btn-primary" onClick={handleSubmit}>
                    Submit
                  </button>

                </div>
              </div>
              {/* /.modal-content */}
            </div>
            {/* /.modal-dialog */}
          </div>
          {/* /.modal */}
        </>
      )}
    </>
  );
};

export default Add_table;
